import { Link } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { useSyncStore } from "../store/syncStore";
import { Button } from "../components/ui/Button";
import { closeDb } from "../db/dexie";
import { resetSyncClient } from "../sync/SyncClient";
import { useNavigate } from "react-router-dom";

const LINKS = [
  { to: "/settings/truck", label: "Truck" },
  { to: "/settings/pay", label: "Pay" },
  { to: "/settings/costs", label: "Costs" },
  { to: "/settings/team", label: "Team" },
  { to: "/settings/plan", label: "Plan" },
  { to: "/settings/import", label: "Import" },
  { to: "/settings/sync", label: "Sync" },
] as const;

export function SettingsScreen() {
  const me = useAuthStore((s) => s.me);
  const pending = useSyncStore((s) => s.pendingCount);
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  async function onSignOut() {
    if (pending > 0) {
      const ok = window.confirm(
        `You have ${pending} unsynced change(s). Sign out anyway?`,
      );
      if (!ok) return;
    }
    resetSyncClient();
    closeDb();
    await signOut();
    navigate("/signin", { replace: true });
  }

  return (
    <div className="stack">
      <h1 className="screen-title">Settings</h1>
      <div className="card">
        <div>{me?.user.name ?? me?.user.email ?? me?.user.phone}</div>
        <div className="muted">
          {me?.org.name} · {me?.role} · {me?.plan.planId}
        </div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="list-item">
            {l.label}
            <span className="muted">→</span>
          </Link>
        ))}
      </div>
      <Button variant="danger" onClick={() => void onSignOut()}>
        Sign out
      </Button>
    </div>
  );
}
